angular.module('env.data.rest.signalR', [

    'env.data.rest.signalR.signalRHub',
    'env.data.rest.signalR.notificationHub'

]);